// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"styles_deleteButton__GNv0f","fadeInOut":"styles_fadeInOut__l1rSd","loader":"styles_loader__0U_se"};